module.exports = __webpack_public_path__ + "img/badge-3d.63d266b3.svg";